<template>
	<div :class="`recht-buttons recht-flex-justify-${alignment}`">
		<div v-for="(btn, index) in buttons" :key="`button-${index}-${_uid}`">
			<a v-if="btn.url" :href="btn.url" :target="btn.target || '_blank'" class="recht-btn">
				{{ btn.text }}
			</a>
			<button v-if="btn.action" @click="btn.action" class="recht-btn">
				{{ btn.text }}
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Buttons',
		data: {},
		props: {
			buttons: {
				type: [Array, Object],
				default: () => {
					return []
				},
			},
			alignment: {
				type: String,
				default: 'left'
			}
		},
		computed: {
			btnsArr() {
				if (Array.isArray(this.buttons)) return this.buttons;

				let result = [];

				if (typeof this.buttons == 'object' && Object.keys(this.buttons) > 0) Object.keys(this.buttons).forEach(btn => {
					result.push(btn);
				});

				return result;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.recht-buttons {
		margin: 0 -1rem;
		margin-top: -2rem;
		display: flex;
		flex-wrap: wrap;

		> div {
			margin: 0 1rem;
			margin-top: 1rem;
		}
	}
</style>
